import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue'

import { CustomList } from '@/models/interfaces'
import { CustomListsView } from '@/models/custom.lists'
import { ListView } from '@/models/docs.list'

import LibraryLayout from '@/app/components/library/LibraryLayout.vue'
import CustomListsBlock from '../listing/CustomListsBlock.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'LibraryCustomLists',
  props: {
    lists: {}
  },
  setup(__props: any) {

const props = __props

const view = ref(createCustomListsListView())

function createCustomListsListView(): ListView {
  const docsView = new CustomListsView(props.lists)
  return new ListView('My Lists', docsView)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LibraryLayout, null, {
    default: _withCtx(() => [
      _createVNode(CustomListsBlock, { view: view.value }, null, 8, ["view"])
    ]),
    _: 1
  }))
}
}

})